export const notificationOpts = {
  title: 'Notification',
  message: 'No message',
  position: 'tr',
  autoDismiss: 3,
};